// Same simple check already used in rapidstor-mono's frontend — good enough
// for "does this look like an email" without pulling in a validation library.
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value: string): boolean {
    return EMAIL_REGEX.test(value.trim());
}
